<template>
  <div class="dizme_tm_section" id="contact">
    <div class="dizme_tm_contact">
      <div class="container">
        <div class="dizme_tm_main_title" data-align="center">
          <span>Contact Me</span>
          <h3>Let’s Bring Your Vision to Life.</h3>
          <p>
            Interested in working together or need more information? Get in
            touch, and I’ll be happy to answer your questions or start a new
            project.
          </p>
        </div>
        <div class="contact_inner">
          <div class="left wow fadeInLeft" data-wow-duration="1s">
            <ul>
              <li>
                <div class="list_inner">
                  <div class="icon orangeBackground">
                    <i class="icon-mail-1 orangeText"></i>
                  </div>
                  <div class="short">
                    <h4>Email</h4>
                    <span
                      ><a href="mailto:xaykham@gmail.com"
                        >xaykham@gmail.com</a
                      ></span
                    >
                  </div>
                </div>
              </li>
              <li>
                <div class="list_inner">
                  <div class="icon orangeBackground">
                    <i class="icon-phone orangeText"></i>
                  </div>
                  <div class="short">
                    <h4>Phone</h4>
                    <span>+856 20 2999 5549</span>
                  </div>
                </div>
              </li>
              <li>
                <div class="list_inner">
                  <div class="icon orangeBackground">
                    <i class="icon-location orangeText"></i>
                  </div>
                  <div class="short">
                    <h4>Address</h4>
                    <span>Vientiane Prefecture, Laos</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="right wow fadeInRight" data-wow-duration="1s">
            <div class="fields">
              <form
                action="/"
                method="post"
                class="contact_form"
                id="contact_form"
                autocomplete="off"
              >
                <div
                  class="returnmessage"
                  data-success="Your message has been received, We will contact you soon."
                ></div>
                <div class="empty_notice">
                  <span>Please Fill Required Fields</span>
                </div>
                <div class="input_list">
                  <ul>
                    <li>
                      <input
                        v-model="name"
                        id="name"
                        type="text"
                        placeholder="Your Name"
                        required
                      />
                    </li>
                    <li>
                      <input
                        v-model="email"
                        id="email"
                        type="text"
                        placeholder="Your Email"
                        required
                      />
                    </li>
                    <li>
                      <input
                        v-model="phone"
                        id="phone"
                        type="number"
                        placeholder="Your Phone"
                        required
                      />
                    </li>
                    <li>
                      <input
                        v-model="subject"
                        id="subject"
                        type="text"
                        placeholder="Subject"
                        required
                      />
                    </li>
                  </ul>
                </div>
                <div class="message_area">
                  <textarea
                    id="message"
                    placeholder="Write your message here"
                    v-model="message"
                    required
                  ></textarea>
                </div>

                <div class="dizme_tm_button">
                  <a id="send_message" href="#" @click.prevent="sendEmail"
                    ><span>Submit</span></a
                  >
                </div>
              </form>
            </div>
          </div>
          <div class="brush_2 wow fadeInRight" data-wow-duration="1s">
            <img src="img/brushes/contact/2.png" alt="" />
          </div>
        </div>
        <!-- <div class="dizme_tm_map wow fadeInUp" data-wow-duration="1s">
          <div class="mapouter">
            <div class="gmap_canvas">
              <iframe
                width="100%"
                height="375"
                id="gmap_canvas"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d869.400563930107!2d102.53575834535164!3d17.988649628621815!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x312469024745f2b9%3A0x7edb13c72487a9d9!2z4LqK4Lqy4LqN4LqE4LuN4LqyIOC6reC6reC6geC7geC6muC6miBHcmFwaGljIERlc2lnbg!5e0!3m2!1sen!2sla!4v1729516575669!5m2!1sen!2sla"
                frameborder="0"
                scrolling="no"
                marginheight="0"
                marginwidth="0"
              ></iframe>
            </div>
          </div>
        </div> -->
        <!-- Get your API here https://www.embedgooglemap.net -->
      </div>
      <div class="brush_1 wow fadeInLeft" data-wow-duration="1s">
        <img src="img/brushes/contact/1.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import emailjs from "emailjs-com";

export default {
  name: "ContactComponent",
  components: {},
  data() {
    return {
      name: "",
      email: "",
      subject: "",
      phone: "",
      message: "",
    };
  },
  methods: {
    async sendEmail() {
      // Validate form fields
      if (!this.name || !this.email || !this.subject || !this.message) {
        alert("Please fill out all required fields before sending the email.");
        return;
      }

      // Email format validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.email)) {
        alert("Please enter a valid email address.");
        return;
      }

      // Create email data object to send to EmailJS
      const emailData = {
        name: this.name,
        email: this.email,
        subject: this.subject,
        phone: this.phone,
        message: this.message,
      };

      try {
        const result = await emailjs.send(
          "service_y0jwdjm", // Replace with your EmailJS service ID
          "template_pkkiinc", // Replace with your EmailJS template ID
          emailData,
          "PVr5YeJbiklxCX16n" // Replace with your EmailJS public key
        );
        if (result.status === 200) {
          alert("Your message has been sent successfully!");
          this.clearForm();
        }
      } catch (error) {
        console.error("EmailJS Error:", error);
        alert(
          "There was an error sending your message. Please try again later."
        );
      }
    },
    clearForm() {
      this.name = "";
      this.email = "";
      this.phone = "";
      this.subject = "";
      this.message = "";
    },
  },
};
</script>
